<template>
    <form class="form-horizontal" @submit.prevent="submit()">
            <div class="form-group" :class="{'has-error': errors['titulo']}">
                <label for="titulo" class="col-sm-2 control-label">Titulo</label>
                <div class="col-sm-10">
                    <input type="text" name="titulo" v-on:keydown="borrar()" v-model="data.titulo" class="form-control">
                    <div class="help-block" v-if="errors['titulo'] != null  ">{{ errors['titulo'] }}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['description']}">
                <label for="description" class="col-sm-2 control-label">Descripción</label>
                <div class="col-sm-10">
                    <editor id="description" v-model="data.description"  v-on:keydown="borrar()"></editor>
                    <div class="help-block" v-if="errors['description'] != null  ">{{ errors['description'] }}</div>
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                    <button type="submit" class="btn btn-primary">Editar</button>
                    <a href="backend" class="btn btn-danger">Cancelar</a>
                </div>
            </div>
    </form>
</template>

<script>
    import Vue from 'vue';
    import Editor from "../Editor.vue"; 

    export default {
        mounted: function() {
            console.log('Component mounted.');
        },
        data: function() {
            const data = {
                id: null,
                titulo: '',
                description: ''
            }
            return {
                data: _.assign(data, this.message),
                errors: []
            }
        },
        props: ['message','edit'],
        components:{
            Editor
        },
        methods:{
            submit: function(){
        
                var self = this;
                self.errors = [];

                if(typeof(self.data.titulo) == undefined || self.data.titulo == '' || self.data.titulo == null) {
                    self.errors['titulo'] = "Este campo es requerido";
                    self.errors['error']  = 1;
                }

                if(typeof(self.data.description) == undefined || self.data.description == '' || self.data.description == null) {
                    self.errors['description'] = "Este campo es requerido";
                    self.errors['error']       = 2;
                }

                if (self.errors['error'] == 1 || self.errors['error'] == 2) {
                    console.log(self.errors);
                    return;
                }else{
                    axios({
                        url: self.edit ? '/backend/condiciones-tramites-sucursal-virtual/formUpdate/'+self.data.id : '/backend/condiciones-tramites-sucursal-virtual/formUpdate/',
                        method: self.edit ? 'PUT' : 'POST',
                        data: self.data,
                    })
                    .then(function(response){
                        // console.log(response.data);
                        window.location.replace(response.data);
                    }).catch(function(error){
                        // console.log(error.response.data)
                        self.errors = error.response.data.errors;
                    });
                }
            },
            borrar: function(){
                var self = this;
                self.errors = [];
            }
        }
    }
</script>